var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_cont"},[_c('router-view'),_c('div',{staticClass:"backTop",on:{"click":function($event){return _vm.backTop()}}},[_c('div',{staticClass:"el-icon-download icons"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }